import { render } from "./PortfolioSegmentation.vue?vue&type=template&id=044baed1&scoped=true"
import script from "./PortfolioSegmentation.vue?vue&type=script&lang=js"
export * from "./PortfolioSegmentation.vue?vue&type=script&lang=js"

import "./PortfolioSegmentation.vue?vue&type=style&index=0&id=044baed1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-044baed1"]])

export default __exports__